<!--<img *ngIf="card_image" mat-card-image src="{{url}}"-->
     <!--alt="{{attachable?.title}}">-->

<!--<img *ngIf="!card_image"  src="{{url}}"-->
     <!--alt="{{attachable?.title}}">-->


<img mat-card-image src="https://material.angular.io/assets/img/examples/shiba2.jpg" alt="Photo of a Shiba Inu">
